import { defineSong } from '../types';

export default defineSong({
  id: 'ilk-adim',
  title: 'İlk Adım',
  level: 1,
  key: 'C',
  bpm: 88,
  beats: 4,
  pattern: 'D-D-D-DU',
  style: 'Folk',
  desc: 'Üç akorla ilk şarkın: yalnızca I, IV ve V. Bası takip et.',
  sections: [
    { name: 'Giriş', bars: ['C', 'C', 'F', 'G'] },
    { name: 'Kıta', bars: ['C', 'F', 'C', 'G', 'C', 'F', 'G', 'C'] },
    { name: 'Nakarat', bars: ['F', 'C', 'G', 'C', 'F', 'C', 'G', 'G'] },
  ],
  // Original lyrics written for kulaktan.com; each word with its length in beats.
  lyrics: [
    { bar: 5, text: 'Elimde:2 gitar,:2 ilk:1 akor:3' },
    { bar: 7, text: 'Parmaklarım:3 biraz:2 acemi:3' },
    { bar: 9, text: 'Bir:1 tel,:1 bir:1 perde,:1 bir:1 nefes:3' },
    { bar: 11, text: 'Kulağım:3 yolu:2 gösterir:3' },
    { bar: 13, text: 'İlk:1 adım,:3 ilk:1 şarkı:3' },
    { bar: 15, text: 'Duyduğumu:4 çalıyorum:4' },
    { bar: 17, text: 'Yavaş:2 yavaş,:2 adım:2 adım:2' },
    { bar: 19, text: 'Kendi:2 sesimi:2 buluyorum:4' },
  ],
});
